import { Ref, watch } from "vue"

export const useResizeObserver = (element: Ref<HTMLElement | null>, callback: (entries: ResizeObserverEntry[]) => void) => {
  const resizeObserver = new ResizeObserver(callback)
  watch(element, () => {
    if (element.value) {
      resizeObserver.observe(element.value)
    }
  })

  return { resizeObserver }
}